var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapeSquareLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 36,
    width: 75,
    height: 75,
    fill: "black",
    fillOpacity: 0.03
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    width: 36,
    height: 36,
    fill: "black",
    fillOpacity: 0.03
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeSquareLight);
export default __webpack_public_path__ + "static/media/shape-square--light.a40fe5af35b8617effadf74dfce136eb.svg";
export { ForwardRef as ReactComponent };